<template>
  <div class="lesson__content -user-">
    <template v-if="!gettingLesson">
      <ul
        v-for="(part, id) in storeParts"
        v-if="storeParts.length !== 0"
        :key="part.id"
        class="lesson__list"
      >
        <li
          v-for="(block, idx) in part.blocks"
          :key="'' + block.id + block.type + block.variety"
          class="lesson__item"
        >
          <component
            :is="getBlock(block)"
            :view-role="viewRole"
            :store="part"
            :block="block"
            :user="user"
            :part-id="part.id"
            :content="block.content"
            :is-first-block="idx === 0"
            :is-last-block="idx === part.blocks.length - 1"
            :is-loading="idx === isLoadingBlockIdx"
            @saveBlock="saveBlock($event, { block, partId: part.id, idx })"
            @deleteBlock="deleteBlockCall({ block, partId: part.id })"
            @moveUp="moveUpBlock()"
            @moveDown="moveDownBlock()"
          >
            <Comment
              v-if="isBlockAnswerID(block.content)"
              class="comment-bg"
              :value="block.content.questionArray"
              :task="block.content.questionArray"
            ></Comment>
          </component>
        </li>
      </ul>
    </template>
    <template v-else>
      <ul class="lesson__list">
        <li v-for="(block, idx) in 5" :key="idx" class="lesson__item">
          <div class="lesson-block main-block">
            <div class="lesson-block__content -ajax-">
              <div class="lesson-block__ajax ajax__line"></div>
              <div class="lesson-block__ajax ajax__line"></div>
            </div>
          </div>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Comment from '../../components/Comment';
import ButtonComponent from '../../components/Button/ButtonIsUser';
import FilesComponent from '../../components/Files/FilesIsUser';
import ImageComponent from '../../components/Image/ImageIsUser';
import TaskComponent from '../../components/Task/TaskIsUser';
import TextComponent from '../../components/Text/TextIsUser';
import TitleComponent from '../../components/Title/TitleIsUser';
import VideoComponent from '../../components/Video/VideoIsUser';
import TestFranchComponent from '../../components/TestFranch/TestIsUser';
import TaskCorrectFranchComponent from '../../components/TaskCorrectFranch/IsUser';
import TaskTeamFranchComponent from '../../components/TaskTeamFranch/IsUser/index';
import MotionCalculatorComponent from '../../components/MotionCalculator/MotionCalculatorIsAdmin';

import AddBlock from '../../components/AddBlockRow';

export default {
  components: {
    ButtonComponent,
    FilesComponent,
    ImageComponent,
    TaskComponent,
    TextComponent,
    TitleComponent,
    VideoComponent,
    AddBlock,
    TestFranchComponent,
    TaskCorrectFranchComponent,
    TaskTeamFranchComponent,
    MotionCalculatorComponent,
    Comment
  },
  props: ['viewRole'],
  data: () => ({
    isLoadingBlockIdx: null
  }),
  computed: {
    ...mapState('auth', {
      user: s => s.data.user
    }),
    ...mapState('coursesLesson', {
      storeParts: s => s.data.parts,
      isStoreLoading: s => s.meta.isLoading,
      gettingLesson: s => s.meta.gettingLesson
    })
  },
  watch: {
    $route() {
      const isLesson = /\/courses\/lesson/.test(this.$route.path);

      if (isLesson) {
        this.getLesson();
      }
    }
  },
  mounted() {
    document.querySelector('html').scrollTop = 0;
  },
  methods: {
    ...mapActions('coursesLesson', ['getLesson', 'editLessonsBlock', 'deleteBlock']),

    ...mapActions('coursesCourse', ['getCourse', 'setAsideMeta']),
    isBlockAnswerID(item) {
      return item.questionArray && item.questionArray[0].answer && item.questionArray[0].answer.id;
    },
    getBlock(block) {
      if (!block) {
        return;
      }

      let blockName;

      if (block.type === 1) {
        switch (block.variety) {
          case 1:
            blockName = 'title';
            break;
          case 2:
            blockName = 'text';
            break;
          case 3:
            blockName = 'video';
            break;
          case 4:
            blockName = 'image';
            break;
          case 6:
            blockName = 'files';
            break;
          case 7:
            blockName = 'button';
            break;
          default:
            console.error(`Undefined block.variety = ${block.variety}`);
            return false;
        }
      } else if (block.type === 2) {
        switch (block.variety) {
          case 1:
            blockName = 'Task';
            break;
          default:
            console.error(`Undefined block.variety = ${block.variety}`);
            return false;
        }
      } else if (block.type === 4) {
        switch (block.variety) {
          case 2:
            blockName = 'Test-franch';
            break;
          default:
            console.error(`Undefined block.variety = ${block.variety}`);
            return false;
        }
      } else if (block.type === 5) {
        switch (block.variety) {
          case 2:
            blockName = 'Task-correct-franch';
            break;
          default:
            console.error(`Undefined block.variety = ${block.variety}`);
            return false;
        }
      } else if (block.type === 6) {
        switch (block.variety) {
          case 2:
            blockName = 'Task-team-franch';
            break;
          default:
            console.error(`Undefined block.variety = ${block.variety}`);
            return false;
        }
      } else if (block.type === 7) {
        switch (block.variety) {
          case 1:
            blockName = 'Motion-calculator';
            break;
          default:
            console.error(`Undefined block.variety = ${block.variety}`);
            return false;
        }
      }

      if (blockName) {
        return `${blockName}-component`;
      }
    },

    async saveBlock(event, { block, partId, idx }) {
      block.content = event;

      await this.setLoading(idx);

      await this.editLessonsBlock({ block, partId });

      await this.setLoading(null);
    },

    deleteBlockCall({ block, partId }) {
      block.blockId = block.id;
      this.deleteBlock({ block, partId });
    },

    setLoading(idx) {
      this.isLoadingBlockIdx = idx;
    }
  }
};
</script>

<style lang="scss" scoped>
.lesson__item {
  margin: 16px 0;
}
</style>
